import { render, staticRenderFns } from "./MsComboBoxDropdown.vue?vue&type=template&id=52eb14c1&scoped=true"
import script from "./MsComboBoxDropdown.vue?vue&type=script&lang=js"
export * from "./MsComboBoxDropdown.vue?vue&type=script&lang=js"
import style0 from "./MsComboBoxDropdown.vue?vue&type=style&index=0&id=52eb14c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb14c1",
  null
  
)

export default component.exports